/**
 * Working draft of the in-game writing for "Angus and the Music
 * Pantheon".  Stored as a single multi-line string and rendered in a
 * scrollable DOS-style sub-canvas on the Angus landing page.
 *
 * Per user iter: line breaks faithfully reflect the paragraph
 * structure of the original 3_angus_writing.docx — every dialogue
 * beat, every action line, every "Press [Enter] / Press [Esc]"
 * pair, and every scene marker sits on its own line.
 */
const ANGUS_WRITING = `Let’s play Angus and the Music Pantheon by Andrew Green
A product of Dreambook Games
_____________________________________________________________________________________
Press [Enter] to continue
Press [Esc] to go to main menu

[v1stcd1]
Two male customers in their early seventies were leaving the Music Pantheon store, both wearing red MAOAWA baseball hats and pairs of sunglasses with gold frames and egg-shaped rims, but one wearing a brown jacket and black pants and the other - a blue jacket and black pants, all denim. The white hairs in their nostrils were making their presence known.
A man in his early seventies enters the Music Pantheon store, wearing a red MAOAWA baseball hat and a pair of sunglasses with gold frames and egg-shaped rims just like the other two customers, but this one also wears a white wifebeater T-shirt and a pair of blue denim jeans with spots of white paint. Coincidentally, this one also had white hairs protruding from his nostrils. Not cognizant of his self-image, this morning the old man decided to wear his favorite flip-flops, exposing his yellow toenails to the public.
Devin, a vivacious guitar sales associate in her early-twenties engaged her first customer of the day. Her pink ponytail clashed with the red work tee.
“Hi-i-i! Welcome to Music Pantheon! What brings you in today?”
“Hi. Listen, honey. My name is Angus McNamara. I am just basically looking for a really good deal. I want to get a really nice guitar, an amp, and I need a cable to connect the guitar to the amp.”
“Oh! Ok. Well, I can help you with that. You said “a really nice guitar”. How nice are we talking? I mean, what’s your budget?”
“Uhm-m-m … well, I don’t have a lot on me.”
“Oh … Ok … Well, … uhm … Luckily, we do have some choices that I think would be right for your pocket. Did you have anything specific in mind, like a Fender Strat or a Tele?”
“Oh, I don’t know anything about that, sweetheart. I’m just looking for a really nice guitar that I can play back in my RV and drive through the country and play on my trips next to my dog Boomer. Little mutt, about this big.”
Angus formed two stop signs with his hands two and a half feet apart.
“Ok. Well, take your time with some of the guitars we have on display and let me quickly come up with a bundle for ya.”
“Oh, … Well … Thank you, buttercup.”
Press [Enter] to continue
Press [Esc] to go to main menu

[v1stcd2]

After some brief venting of her frustration with the customer to the store manager, John Curry, she took note of the brand and model of the guitar her customer was playing. With a simple solution in mind, she climbed a ladder to reach for the shelf above the glass cases with used guitar and bass effects pedals, grabbed a guitar pack potentially suitable for the situation, and, after a careful descent down the ladder, brought it over to Angus.
“What do you think? … AND it’s on sale for $129.99. THAT is a good deal,” Devin said.
After taking a good look at the bundle, which featured an electric guitar modeled after the Fender Telecaster and adorned in candy apple red finish, Angus muttered “Oh, that is great. Can I play it?”
After he spent a minute playing the floor models of both the guitar and the amp, not even playing music but simply making sounds, he and Devin proceeded to checkout. During the exchange the old man brought up a particular idea he had in mind.
“Look, since I’m a first-time customer here, I was wondering if you could do a lil sumthin’ on this set.”
“Oh! … Well, we already have a deal on this pack. It was originally $149.99 but we brought it down to $129.99 for our customers, like yourself, who are just getting started.”
This was about a millionth time she heard that kind of cheap talk from a customer.
“Well, I see you have all these nice guitars that are, like, five-six thousand dollars each, and they are already on sale, and you have all these professional players playing them, so these guitars are not for first-time players and yet  they  are on sale. I mean, what’s up with tha’?”
After having given a little thought to what to say to Angus, Devin replied:
“Well, those high-end guitars have not been selling well as of late, so our corporate and the vendors agreed that they would have to be marked down.”
An expression of confusion reflected on Angus’ face. Unhappy with Devin’s explanation, he simply retorted:
Press [Enter] to continue
Press [Esc] to go to main menu

[v1stcd3]

“Look, I don’t know what kind of scam you guys are running here, but … Look! I’m a first-time customer here, OK?! I came here hoping you could do a really good deal for me. That’s all I want. I want you to do a lil sumthin’ for me here. I mean, … work with me here.”
“U-uh …”
“Let me speak to your manager.”
“... Ok. Just a moment, please.”
Devin turned around and left the cash register to see John, the store manager, in his office. Accompanied by Devin, John came out of the office, exhaling. Approaching the cash register Angus was standing next to, John opened the conversation.
“Hey, man. How is it going?”
“Hi.”
“So, from what Devin relayed to me, you are not happy with the pricing on our options …”
It is probably best for the reader to not know how the middle of that conversation went. Hell, even the writer of this piece is tired of elaborating on the stupidity and egocentricity of Angus McNamara. Long story short, …
“Look, I’ll buy the pack from you for 90 dollars, OK? Listen, I wanna do a cash deal.”
He pulls out a wad of 90 single-dollar bills and places them on the counter in stacks of ten.
“Ninety dollars out the door. Cash!”
He stretched his left hand horizontally out to John then pointed at John with the index finger.
“And no funny business!”
“I’m sorry, man, but $140.03 is our final offer. All sales are final.”
Angus quickly collected his money, shoved it in his right pocket, turned around, and approached the front doors. He suddenly stopped and turned around.
“I’ll show you kids that I don’t play around,” he grumbled. “Fun time is over!”
Press [Enter] to continue
Press [Esc] to go to main menu

[v1animexit]
[Store screen animation: Angus walks towards the doors, turns around, shakes his left fist three times, then turns back around and walks out of the store.]
Press [Enter] to skip
Press [Esc] to go to main menu

[v2bfs1]

The store gang once again fell to the lull of having to live and work through two more hours of tedium at the store … until …
“It’s that guy again,” Devin announced, “... and … Is that … Is that a gun?!”
The staff realized what Angus meant by what he said before.
“Oh, dear Christ,” Garth uttered. He became the store’s new addition as the audio sales associate just a month ago.
“I’m calling 911!” he added.
John Curry, the store manager, came out of his office. To get an idea of where everyone was looking, he came closer to the center of the sales floor, coming near the cash register perimeter before getting a good enough angle to spot an irate Angus McNamara with a Beretta M9 handgun in his right hand.
“Everyone, clear the floor!” John shouted. “Les, hand me my shotgun!”
Press [Enter] to skip
Press [Esc] to go to main menu

[v2bfs1]
[Store screen animation: Les hands John his shotgun. Everyone but John clears the sales floor. Angus enters the store.]

[v2bfs1]
“Let’s get this party started.”
If John was ready, he felt ready.
Press [Enter] to skip
Press [Esc] to go to main menu

[v2s1]
[Controls text card:]
Movement:
Up  - W / Up arrow
Left  - A / Left arrow
Down  - S / Down arrow
Right  - D / Right arrow
Actions:
Fire - Ctrl
Press [Enter] to skip
Press [Esc] to exit game

[v2s1]
[Interactive environment: Angus has a hand gun, John has a shotgun]
[Objective pop-up: “Sufficiently wound Angus McNamara”]
[Objective pop-up: “Survive Angus McNamara’s attack”]
[If john_health_0:  start shootout_1]
Press [Enter] to skip
Press [Esc] to exit game

[v2afs1]
[Animation: Angus rushes to the front entrance of the store, wounded. He stops, turns around.]

[v2afs1]
“This ain’t over, Mr. Curry! I’ll be back and get my guitar pack!”
Press [Enter] to skip
Press [Esc] to exit game

[v2afs1]
[Animation: Angus shakes his left fist twice, then leaves.]
Press [Enter] to skip
Press [Esc] to exit game

[v2afs1]
“Everybody OK?!”
Much to the surprise of everybody else on the floor John seemed rather unshaken by the recent event. Minutes later the entire sales floor realized that the surly gun-wielding customer managed to make his escape and remain undetected.
Press [Enter] to skip
Press [Esc] to exit game

[v3bfs2]

A police squad was assigned to secure the front entrance to the building to allow the company to continue conducting business at the branch, yet fears mounted around the notion of visiting the local Music Pantheon branch. But what followed were days of nothing but recovery and things going back to normal. The resilient team at the Music Pantheon even managed to color their days with occasional humor.
A month had passed since Angus’ unwelcome visit.
“Holy shit! It’s Angus again!” Devin exclaimed.
“The cops didn’t get him?!” Garth added. Then he noticed the stone-faced Angus wielding a Remington 870 in his hands.
“He’s got a shotgun! Brace yourselves!” he warned. “I’m calling 911!”
“Alright, everyone!” John called to attention. “Just like the last time. Clear the floor! And Les! Get me my rifle. I’ll handle this scumbag.”
Press [Enter] to skip
Press [Esc] to exit game

[v3s2]
[Animation: Les hands John his AR-15 Carbine, Angus walks in with a shotgun]
[Interactive environment: Angus has a shotgun, John has an AR-15 Carbine]
[Objective pop-up: “Sufficiently wound Angus McNamara”]
[Objective pop-up: “Survive Angus McNamara’s attack”]
[If john_health_0:  start shootout_2]

[v3afs2]
[Animation: Angus rushes to the front doors, wounded. He stops, turns around.]

[v3afs2]
“You really think this is over, Mr. Curry?! Ya ain’t got another thing comin’!” Angus was panting. “I will be back, Mr. Curry, and I will get my guitar pack!”
Press [Enter] to continue
Press [Esc] to exit game

[v3afs2]
[Animation: Angus shakes his left fist once, freezes, then leaves.]

[v4bfs3]

New security detail was assigned to the location. The store was all that the employees had. The same faces remained. This wasn’t a family. This was a pack. Yet very little changed at the store during that whole year of peace. The local authorities and the corporate management of Music Pantheon eventually decided to dismiss the security around the store’s perimeter and allow the business to go back to its former self using minimal security services.
“Oh, motherfuck me,” John uttered. But it was too late - the ghost of the past was already inside the store, ready to unleash hell at any moment.
“He’s got an M249!” Garth exclaimed. “The fuck do we do?!”
“One last time, everyone! … I got this,” John added confidently.
Before anyone moved from their place, Angus quickly interjected.
“Nobody move!”
This was Angus at his most intimidating. He stood frozen for another moment before speaking.
“You see, Mr. Curry? All you have to do is take my money - ninety dollars, that’s all - and give me my damn guitar pack!”
“We are not one of your Mom-N’-Pop shops where you can haggle your way, dickhead.”
“Alright! That’s enough, big guy! Play time is over … ‘cuz I don’t play around!”
“Then don’t leave my store without your birthday present, fuckface!”
John swiftly grabbed Angus’ present from a cubbyhole nearby.
Press [Enter] to continue
Press [Esc] to exit game

[v4s3]
[Interactive environment: Angus has an M249, John has a rocket launcher]
[Objective pop-up: “KILL Angus McNamara”]
[Objective pop-up: “Survive Angus McNamara’s attack”]
[If john_health_0:  start shootout_3]

[v4afs3]
John looked around at the state of the sales floor with mere confusion instead of bewilderment.
“Oh, man. Look at this mess. … That’s a lot of explaining to do. … Let’s just hope the forensic team will help me scoop the remains.”
Press [Enter] to continue
Press [Esc] to exit game

[credits]
Congratulations! You’ve successfully redefined the meaning of *customer service*!
I thank you for playing …
Angus and the Music Pantheon
A product of Dreambook Games
2425 Valdez St., Oakland, CA 94612
(775) 762-5595
andrewgreenofficial@gmail.com
Press [Enter] to continue
Press [Esc] to exit game

[credits]
Directed by Andrew Green
Produced by Andrew Green
Written by Andrew Green
Game Design   Andrew Green
Map Design    Andrew Green
Music         Seriously, it’s just me.
Sound Design  Look, even if you think you don’t know how to make a game, will you help me out?
Quality Assurance   Still, … me and you, basically.
A product of Dreambook Games
2425 Valdez St., Oakland, CA 94612
(775) 762-5595
andrewgreenofficial@gmail.com
Press [Enter] to continue
Press [Esc] to exit game

[credits]
Please stay tuned for our new upcoming game:
Ohio Wells and the Rings of Triumph
[insert poster of the game here]
A product of Dreambook Games
2425 Valdez St., Oakland, CA 94612
(775) 762-5595
andrewgreenofficial@gmail.com
Press [Enter] to continue
Press [Esc] to exit game

________________________________________________________________________________
[End of game]
`;

// Per user iter: insert an em-dash before any line that begins with a
// left double quotation mark (curly U+201C), so it reads like a
// classical "dialogue dash" cue for the story character speaking.
const ANGUS_WRITING_FORMATTED = ANGUS_WRITING.replace(/\n\u201C/g, "\n\u2014 \u201C");

export default ANGUS_WRITING_FORMATTED;
